'use strict';
var React = require('react');
var assetsHelper = require('../../helper/assetsHelper');
var util = require('../../helper/util');
var styleHelper = require('../../helper/styleHelper');
var propConst = require('../../constants/propConst');
var ColorImage = require('../common/ColorImage');
var _ = require('underscore');

var IOSStatusBar = React.createClass({
  render: function () {
    var bgColor = styleHelper.getBackgroundColor(this.props);
    var isLightColor = util.Color.isLight(bgColor);
    var color = styleHelper.getPropertyValue(this.props, propConst.FOREGROUND_COLOR);
    var w = styleHelper.getWidth(this.props);
    var h = styleHelper.getHeight(this.props);
    if (_.isUndefined(this.props.IsAutoTextColor) || this.props.IsAutoTextColor) {
      if (isLightColor) {
        color = '#000'
      } else {
        color = '#fff'
      }
    }
    return (
      <div className="component-IOSStatusBar" style={{backgroundColor: bgColor}}>
        <ColorImage {...{
          src: assetsHelper.getComponentAsset('StatusBar(IOS)'),
          height: 20,
          width: '100%',
          color: color,
          gridRect: {
            left: 107,
            right: 250
          }
        }} style={{
          width: '100%',
          height: 20,
          position: 'absolute',
          top: (h - 20) / 2
        }}/>
        <div className="time">
          <label style={{
            lineHeight: h + 'px',
            color: color,
            fontSize: Math.min(h, 20) / 2
          }}>4:20PM</label>
        </div>
      </div>
    );
  }
});

module.exports = IOSStatusBar;



// WEBPACK FOOTER //
// ./src/views/Components/IOSStatusBar.jsx